export default {
  easyLanguage: 'Linguaggio semplice',
  videoDoesNotYetExist: 'Il video non esiste ancora'
}



// WEBPACK FOOTER //
// ./src/i18n/common/it.js